import { TrackingInformationState } from 'components/search/bex/interfaces';

const initialTrackingInformationState: TrackingInformationState = {
  trackingInformationCJPID: '',
  trackingInformationCJSID: '',
};

export { initialTrackingInformationState };
